import React, { useState } from 'react';
import { actualizarActividad } from '../../services/ActividadesService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import { FaCalendarAlt } from 'react-icons/fa';

// Funciones de notificación estandarizadas
const showSuccessToast = (message) => {
    toast.success(message, {
        position: 'top-right',
        autoClose: 3000,
        style: { marginTop: '10px' }
    });
};

const showErrorToast = (message) => {
    toast.error(message, {
        position: 'top-right',
        autoClose: 3000,
        style: { marginTop: '10px' }
    });
};

const Actualizar_actividad = ({ actividad, onClose, onActualizacionExitosa }) => {
    const [datosActividad, setDatosActividad] = useState({
        nombre: actividad.nombre,
        descripcion: actividad.descripcion || '',
        fecha_programada: moment(actividad.fecha_programada).format('YYYY-MM-DD'),
        estado: actividad.estado,
        observaciones: actividad.observaciones || ''
    });
    const [nombreError, setNombreError] = useState('');
    const [fechaError, setFechaError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDatosActividad(prev => ({ ...prev, [name]: value }));
        if (name === 'nombre') setNombreError('');
        if (name === 'fecha_programada') {
            const fechaSeleccionada = moment(value);
            const fechaActual = moment().startOf('day');
            setFechaError(fechaSeleccionada.isBefore(fechaActual) ? 'La fecha no puede ser anterior a la fecha actual' : '');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let hasError = false;

        if (!datosActividad.nombre.trim()) {
            setNombreError('El nombre de la actividad es requerido');
            hasError = true;
        }

        if (datosActividad.fecha_programada !== actividad.fecha_programada && datosActividad.estado !== 'completada') {
            const fechaSeleccionada = moment(datosActividad.fecha_programada);
            if (fechaSeleccionada.isBefore(moment().startOf('day'))) {
                setFechaError('La fecha no puede ser anterior a la fecha actual');
                hasError = true;
            }
        }

        if (hasError) return;

        try {
            const cambios = {};
            if (datosActividad.nombre !== actividad.nombre) cambios.nombre = datosActividad.nombre;
            if (datosActividad.descripcion !== actividad.descripcion) cambios.descripcion = datosActividad.descripcion;
            if (datosActividad.fecha_programada !== moment(actividad.fecha_programada).format('YYYY-MM-DD')) {
                cambios.fecha_programada = datosActividad.fecha_programada;
            }
            if (datosActividad.estado !== actividad.estado) cambios.estado = datosActividad.estado;
            if (datosActividad.observaciones !== actividad.observaciones) cambios.observaciones = datosActividad.observaciones;

            await actualizarActividad(actividad.id_actividad, cambios);
            showSuccessToast('Actividad actualizada exitosamente');
            onActualizacionExitosa();
            onClose();
        } catch (error) {
            showErrorToast('Error al actualizar la actividad');
            console.error(error);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-8 rounded-lg w-[400px] max-w-full mx-2 shadow-lg">
                <h2 className="text-lg font-bold text-gray-800 mb-3">Editar Actividad</h2>
                <form onSubmit={handleSubmit} className="space-y-2">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Nombre de la Actividad
                        </label>
                        <input
                            type="text"
                            name="nombre"
                            value={datosActividad.nombre}
                            onChange={handleChange}
                            placeholder="Ej: Tarea de matemáticas"
                            className={`w-full px-3 py-1.5 bg-white border text-sm text-gray-500 border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-transparent transition-all duration-200 ${
                                nombreError ? 'border-red-500' : ''
                            }`}
                        />
                        {nombreError && (
                            <p className="text-red-500 text-xs mt-1">{nombreError}</p>
                        )}
                    </div>
                    
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Descripción
                        </label>
                        <textarea
                            name="descripcion"
                            value={datosActividad.descripcion}
                            onChange={handleChange}
                            placeholder="Describe los detalles de la actividad"
                            className="w-full px-3 py-1.5 bg-white border text-sm text-gray-500 border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
                            rows="2"
                        />
                    </div>
                    
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Fecha Programada
                        </label>
                        <div className="relative">
                            <input
                                type="date"
                                name="fecha_programada"
                                value={datosActividad.fecha_programada}
                                onChange={handleChange}
                                min={moment().format('YYYY-MM-DD')}
                                className={`w-full px-3 py-1.5 bg-white border text-sm text-gray-500 border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-transparent pl-8 transition-all duration-200 ${
                                    fechaError ? 'border-red-500' : ''
                                }`}
                                required
                            />
                            <FaCalendarAlt className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
                        </div>
                        {fechaError && (
                            <p className="text-red-500 text-xs mt-1">{fechaError}</p>
                        )}
                    </div>
                    
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Estado de la Actividad
                        </label>
                        <select
                            name="estado"
                            value={datosActividad.estado}
                            onChange={handleChange}
                            className="w-full px-3 py-1.5 bg-white border text-sm text-gray-500 border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
                        >
                            <option value="pendiente">Pendiente</option>
                            <option value="completada">Completada</option>
                        </select>
                    </div>

                    {datosActividad.estado === 'completada' && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Observaciones
                            </label>
                            <textarea
                                name="observaciones"
                                value={datosActividad.observaciones}
                                onChange={handleChange}
                                placeholder="Agrega comentarios sobre la actividad completada"
                                className="w-full px-3 py-1.5 bg-white border text-sm text-gray-500 border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-transparent transition-all duration-200"
                                rows="2"
                            />
                        </div>
                    )}

                    <div className="flex justify-end space-x-2 pt-3">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-1.5 bg-gray-100 text-sm text-gray-700 rounded-md hover:bg-gray-200 transition-colors duration-200 font-medium"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-1.5 bg-indigo-600 text-sm text-white rounded-md hover:bg-indigo-700 transition-colors duration-200 font-medium"
                        >
                            Guardar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Actualizar_actividad;
